const styles = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: "transparent",
  height: "135px",
  fontFamily: '"Gotham SSm A", "Gotham SSm B"',
  fontWeight: 700,
  fontSize: "16px",
  color: "#252528",
};

export default styles;
